var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"filter-button",on:{"click":_vm.toggle}},[_c('material-icon',{attrs:{"size":"large","icon":_vm.icon}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }